import { clientApi } from './api';

const axiosClient = clientApi;
export default axiosClient;
